{
  "global": {
    "backToHome": "Вернуться на главную страницу",
    "errors": {
      "unhandledError": "Произошла необработанная ошибка",
      "serverError": "Произошла ошибка. Пожалуйста, повторите попытку позже.",
      "accessDenied": "Доступ запрещен"
    }
  },
  "header": {
    "logoAlt": "CIM Bank - Швейцарский частный банк",
    "btnLogout": "Выйти",
    "btnMessages": "Сообщения",
    "btnRegistrations": "Мои регистрации"
  },
  "footer": {
    "copyright": "© CIM Banque SA - Женева, Лугано, Воллерау - Швейцария",
    "contactFormLabel": "Форма обратной связи",
    "contactFormSubtitle": "Пожалуйста, используйте нашу форму обратной связи, чтобы связаться с одним из наших специалистов. Мы будем рады вам помочь!",
    "relationshipManagerLabel": "Мой менеджер по работе с клиентами",
    "contactHours": "С понедельника по пятницу, с 08:30 до 18:30",
    "contactPhone": "+41 (0)58 225 50 50"
  },
  "modal": {
    "confirmButton": "OK",
    "cancelButton": "Отмена",
    "remark": "Замечание"
  },
  "attachment": {
    "fileNoName": "Безымянный файл",
    "errors": {
      "noMultipleFilesAllowed": "Одновременно можно загрузить только один файл",
      "allowedTypes": "Разрешены только изображения или PDF-файлы",
      "unhandledError": "При загрузке файла произошла ошибка. Проверьте размер файла (максимум 8 МБ) и повторите попытку позже."
    }
  },
  "gender": {
    "gender": "Пол",
    "male": "Мужской",
    "female": "Женский",
    "genderError": "Пол обязателен"
  },
  "maritalStatusEnum": {
    "single": "Одинокий",
    "married": "Женатый",
    "divorced": "В разводе",
    "widower": "Вдовец",
    "civilUnion": "Гражданский брак"
  },
  "counterpartyOperationTypeEnum": {
    "import": "Импортировать",
    "export": "Экспортировать",
    "intermediation": "Посредничество",
    "fees": "Сборы",
    "logisticsAndTransport": "Логистика и транспорт",
    "other": "Другой"
  },
  "counterpartyCashFlowTypeEnum": {
    "incoming": "Входящий",
    "outgoing": "Исходящий"
  },
  "signatureTypeEnum": {
    "signature": "Подпись",
    "signatureIndividual": "Индивидуальная",
    "signatureCollective": "Коллективная",
    "none": "Никто"
  },
  "validation": {
    "onlyChars": "Это поле должно содержать только символы или цифры"
  },
  "messages": {
    "messagesDialogTitle": "Сообщения",
    "messageBy": "от {username}",
    "messageOn": "в {date}",
    "messageSeen": "прочитано {username} в {date}",
    "addMessage": "Введите сообщение...",
    "addAttachment": "Добавить вложение",
    "submit": "Отправить"
  },
  "login": {
    "email": "Адрес электронной почты",
    "btnRequestAccess": "Получить безопасную ссылку",
    "openAccount": "Открыть счет?",
    "description": "Мы отправим вам электронное письмо со ссылкой, которая обеспечит вам безопасный доступ к нашей платформе.",
    "successMessage": "Пожалуйста, проверьте свою электронную почту и подключитесь по защищенной ссылке.",
    "errors": {
      "invalidToken": "Ссылка недействительна. Пожалуйста, введите свой адрес электронной почты, и мы вышлем вам электронное письмо со ссылкой, которая обеспечит вам безопасный доступ к нашей платформе.",
      "genericError": "Произошла ошибка. Пожалуйста, повторите попытку позже.",
      "email": "Требуется адрес электронной почты",
      "emailInvalid": "Электронная почта должна быть действующей",
      "noRecipientFound": "Этот адрес электронной почты не найден"
    }
  },
  "open": {
    "btnBack": "Назад",
    "btnNext": "ДАЛЕЕ",
    "btnSubmit": "Отправить",
    "yes": "ДА",
    "no": "НЕТ",
    "tabs": {
      "accountType": "тип счета",
      "individual": {
        "contactInformation": "Личный контакт",
        "additionalInformation": "Дополнительная информация",
        "confirmation": "Подтверждение"
      },
      "company": {
        "companyInformation": "Ваша компания",
        "contactInformation": "Личный контакт",
        "additionalInformation": "Дополнительная информация",
        "confirmation": "Подтверждение"
      }
    },
    "accountType": {
      "title": "Выберите тип счета",
      "subtitle": "Приступим! Выберите тип счета, который вы хотите открыть.",
      "optionIndividual": "Лицевой счет",
      "optionIndividualInformation": "Вступительный взнос в размере <span class=\"cim-pink\">90</span> CHF/EUR/USD",
      "optionCorporate": "Корпоративный счет",
      "optionCorporateInformation": "Вступительный взнос в размере <span class=\"cim-pink\">500</span> CHF/EUR/USD",
      "warningPotential": ""
    },
    "individual": {
      "contactInformation": {
        "title": "Заполните свои личные и контактные данные",
        "firstName": "Имя",
        "middleName": "Второе имя",
        "lastName": "Фамилия",
        "email": "Адрес электронной почты",
        "repeatEmail": "Повторно введите адрес электронной почты",
        "mobilePhone": "Мобильный телефон",
        "repeatMobilePhone": "Повторно введите мобильный телефон"
      },
      "additionalInformation": {
        "title": "Заполните дополнительную информацию",
        "birthDate": "Дата рождения",
        "cityOfBirth": "Город рождения",
        "countryOfBirth": "Страна рождения",
        "countryOfResidence": "Страна проживания",
        "nationality": "Национальность",
        "preferredLanguage": "Предпочтительный язык"
      },
      "confirmation": {
        "greetings": "Благодарим!",
        "messageInvited": "Мы отправили вам электронное письмо с дальнейшими инструкциями по заполнению запроса на открытие счета. Перейдите по ссылке в письме, чтобы определить свой пароль и подключиться к MyCIM. Если вы не получили сообщение, проверьте папку «Спам».",
        "message": "Менеджер по работе с клиентами свяжется с вами в ближайшее время и начнет процедуру открытия счета."
      },
      "errors": {
        "firstName": "Имя обязательно",
        "lastName": "Фамилия обязательна",
        "email": "Электронная почта обязательна",
        "emailInvalid": "Электронная почта должна быть действующей",
        "emailsDifferent": "Электронная почта должна совпадать",
        "mobilePhone": "Номер мобильного телефона обязателен и должен быть действительным (например, +41XXXXXXXXXX)",
        "mobilePhonesDifferent": "Мобильные телефоны должны соответствовать",
        "birthDate": "Дата рождения является обязательной и должна быть действительной",
        "birthDateFuture": "Дата рождения не может быть позже сегодняшнего дня",
        "cityOfBirth": "Город рождения обязателен",
        "countryOfBirth": "Страна рождения обязательнa",
        "countryOfResidence": "Страна проживания обязателенa",
        "nationality": "Национальность обязательнa",
        "preferredLanguage": "Предпочтительный язык обязателен"
      }
    },
    "company": {
      "companyType": {
        "domiciliaryTitle": "Внереализационная деятельность",
        "domiciliarySubtitle": "Владение долями участия или активами.",
        "operatingTitle": "Операционная компания",
        "operatingSubtitle": "Оказание услуг или ведение торговли.",
        "otherTitle": "Другой",
        "otherSubtitle": "Траст, фонд или ассоциация, страховая схема."
      },
      "roleInCompany": {
        "noRole": "Никакой формальной роли в структуре",
        "beneficial": "Бенефициарный владелец",
        "shareholder": "Акционер",
        "signatory": "Подписант",
        "introducingPartner": "Партнер представитель",
        "director": "Директор"
      },
      "companyInformation": {
        "title": "Выберите тип вашей компании",
        "companyName": "Название компании",
        "companyTypeRemark": "Обоснование внереализационная деятельность",
        "incorporationCountry": "Страна регистрации",
        "contactTheBank": "Пожалуйста, свяжитесь с банком для продолжения процедуры открытия"
      },
      "contactInformation": {
        "title": "Заполните свои личные данные",
        "info": "Пожалуйста, укажите свои контактные данные, по которым мы сможем с вами связаться",
        "firstName": "Имя",
        "lastName": "Фамилия",
        "role": "Какова ваша роль в компании?",
        "cimBanqueCustomer": "Вы клиент CIM Banque?",
        "accountNumber": "Какой у вас номер счета?",
        "howHeard": "Откуда вы узнали о CIM Banque?"
      },
      "additionalInformation": {
        "title": "Заполните свои контактные данные",
        "email": "Адрес электронной почты",
        "repeatEmail": "Повторно введите адрес электронной почты",
        "mobilePhone": "Мобильный телефон",
        "repeatMobilePhone": "Повторите мобильный телефон",
        "preferredLanguage": "Предпочтительный язык"
      },
      "confirmation": {
        "greetings": "Благодарим!",
        "messageInvited": "Мы отправили вам электронное письмо с дальнейшими инструкциями по заполнению запроса на открытие счета. Перейдите по ссылке в письме, чтобы определить свой пароль и подключиться к MyCIM. Если вы не получили сообщение, проверьте папку «Спам».",
        "message": "Менеджер по работе с клиентами свяжется с вами в ближайшее время и начнет процедуру открытия счета."
      },
      "errors": {
        "companyName": "Название компании обязательно",
        "incorporationCountry": "Страна регистрации обязательна",
        "role": "Роль обязательна",
        "alreadyCustomer": "Это поле обязательно к заполнению",
        "accountNumber": "Номер счета обязателен",
        "firstName": "Имя обязательно",
        "lastName": "Фамилия обязательна",
        "email": "Электронная почта обязательна",
        "emailInvalid": "Электронная почта должна быть действующей",
        "emailsDifferent": "Электронная почта должна совпадать",
        "mobilePhone": "Номер мобильного телефона обязателен и должен быть действительным (например, +41XXXXXXXXXX)",
        "mobilePhonesDifferent": "Мобильные телефоны должны соответствовать",
        "preferredLanguage": "Предпочитаемый язык является обязательным",
        "companyTypeRemark": "Требуется oбоснование внереализационная деятельность"
      }
    }
  },
  "register": {
    "btnBack": "Назад",
    "btnPrevious": "Предыдущий",
    "btnCancel": "Отмена",
    "btnNext": "ДАЛЕЕ",
    "btnContinue": "Продолжить",
    "btnSubmit": "Отправить",
    "btnSave": "Сохранить",
    "yes": "Да",
    "no": "Нет",
    "tabs": {
      "individualAccountUsage": "Цель аккаунта",
      "individualInformation": "Персональные данные",
      "familyAndJob": "Семья и работа",
      "contract": "Договор",
      "yourDocuments": "Ваши документы",
      "companyAccountUsage": "Цель аккаунта",
      "companyInformation": "Информация о компании",
      "companyStructure": "Структура компании",
      "companyTransaction": "Информация о транзакциях",
      "companyCounterparties": "Контрагенты",
      "underReview": "процессе рассмотрения",
      "refused": "отклонен",
      "initialDeposit": "Начальный Депозит"
    },
    "prospectSelection": {
      "title": "MyCIM ожидающие регистрации",
      "continue": "Продолжить",
      "openAnotherAccount": "Открыть другой аккаунт"
    },
    "individualAccountUsage": {
      "title": "Выберите цель аккаунта для {displayName}",
      "accountUsages": {
        "savingsAndInvestments": "Сбережения и инвестиции",
        "currentAccount": "текущий счет",
        "other": "Другое, указать"
      }
    },
    "companyAccountUsage": {
      "title": "Выберите цель аккаунта для {displayName}",
      "accountUsages": {
        "commercialActivity": "Kоммерческая деятельность",
        "savingsAndInvestments": "Сбережения и инвестиции",
        "currentAccount": "текущий счет",
        "other": "Другое, указать"
      }
    },
    "individualInformation": {
      "title": "Заполнить персональные данные счета для {displayName}",
      "subtitle": "Уважаемый {username}, нам нужно, чтобы вы ответили на следующие вопросы",
      "addressLine1": "Адрес",
      "zipCode": "Почтовый индекс",
      "city": "Город",
      "residenceCountryIsoCode": "Страна проживания",
      "passportNumber": "Номер паспорта",
      "passportExpirationDate": "Срок действия паспорта",
      "taxationCountryIsoCode": "Страна налогообложения",
      "tinNumber": "ИНН",
      "hasTinNumber": "У меня нет ИНН",
      "relationWithUSA": "Отношения с США",
      "isLinkedToUnitedStates": "Вы имеете отношение к США?",
      "hasUSPassportOrGreenCard": "У вас есть паспорт гражданина США или грин-карта?",
      "hasSpentSubstantialTimeInUS": "Вы когда-нибудь пребывали в США на протяжении более 90 дней?",
      "isUSResidentForAnyOtherReason": "Вы владеете недвижимостью в США?",
      "errors": {
        "addressLine1": "Адрес обязателен",
        "zipCode": "Почтовый индекс обязателен",
        "city": "Город обязателен",
        "passportNumber": "Номер паспорта обязателен",
        "passportExpirationDate": "Срок действия паспорта является обязательным и должен быть действительным",
        "passportExpirationDateOutdated": "Дата должна быть больше, чем сегодняшняя дата",
        "residenceCountryIsoCode": "Страна обязательна",
        "taxationCountryIsoCode": "Страна налогообложения обязательна",
        "tinNumber": "ИНН обязателен",
        "isLinkedToUnitedStates": "Поле США является обязательным",
        "hasUSPassportOrGreenCard": "Пожалуйста, выберите значение",
        "hasSpentSubstantialTimeInUS": "Пожалуйста, выберите значение",
        "isUSResidentForAnyOtherReason": "Пожалуйста, выберите значение"
      }
    },
    "individualFamily": {
      "family": "Семья {displayName}",
      "maritalStatus": "Семейное положение",
      "spouse": "Супруга / Партнер",
      "needJointAccount": "Мне нужен совместный счет",
      "children": "Дет",
      "addChild": "Добавить ребенка",
      "job": "Работа {displayName}",
      "roleLabel": "Работа / род занятий 1/2",
      "jobLabel": "Работа / род занятий 2/2",
      "workplaceCountry": "Страна расположения рабочего места",
      "firstName": "Имя",
      "lastName": "Фамилия (Девичья фамилия)",
      "errors": {
        "maritalStatus": "Семейное положение обязателено",
        "job": "Требуется работа",
        "workplaceCountryIsoCode": "Требуется расположение рабочего места",
        "partnerFirstName": "Имя обязательно",
        "partnerLastName": "Фамилия обязательна"
      }
    },
    "individualInProgressModal": {
      "title": "Спасибо за информацию",
      "subtitle": "Ваши данные успешно сохранены",
      "message": "Пожалуйста, проверьте, все ли ваши данные верны, прежде чем продолжить, так как вы не сможете изменить их после перехода к следующему этапу"
    },
    "individualContract": {
      "title": "Договор, положения и условия",
      "subtitle": "Уважаемый {username}, вы собираетесь подписать контракт. Пожалуйста, уделите немного времени и ознакомьтесь с его условиями.",
      "openAndRead": "Открыть и прочитать проект моего соглашения",
      "contractAgreement": "Я ознакомился(-ась) и принимаю условия договора",
      "termsAgreement": "Я ознакомился(-ась) и принимаю <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/06_general-terms-and-conditions-en.pdf\">условия и положения CIM Banque</a>",
      "feesAgreement": "Я ознакомился(-ась) и принимаю условия о <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/ru/fees-for-private-accounts\">сборах и комиссиях CIM Banque</a>",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Я ознакомился(-ась) и принимаю <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/special_risks_security_trading.pdf\">Риски, связанные с торговлей финансовыми инструментами</a>",
      "errors": {
        "contractAgreement": "Это поле обязательно к заполнению",
        "termsAgreement": "Это поле обязательно к заполнению",
        "feesAgreement": "Это поле обязательно к заполнению",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Это поле обязательно к заполнению"
      }
    },
    "individualDocuments": {
      "title": "Загрузить документы для {displayName}",
      "certificateOfResidence": "Справка о подтверждении статуса налогового резидента",
      "certificateOfResidenceSubtitle": "Перетащите или щелкните, чтобы загрузить <span class='document-subtitle-string'>Справку о подтверждении статуса налогового резидента*</span> для каждого владельца",
      "passport": "Паспорта",
      "passportSubtitle": "Перетащите или щелкните, чтобы загрузить <span class='document-subtitle-string'>Паспорта</span> для каждого владельца",
      "datedLess": "*Датированные менее 12 месяцев назад  и выданные компетентным государственным органом — Внимание, счета за коммунальные услуги и банковские выписки больше не принимаются",
      "errors": {
        "allowedTypes": "Разрешены только изображения или PDF-файлы",
        "unhandledError": "При загрузке файла произошла ошибка. Проверьте размер файла (максимум 8 МБ) и повторите попытку позже."
      }
    },
    "companyInformation": {
      "title": "Заполните информацию о вашей компании для {displayName}",
      "addressLine1": "Адрес",
      "addressLine2": "Дополнительный адрес",
      "zipCode": "Почтовый индекс",
      "city": "Город",
      "residenceCountryIsoCode": "Страна проживания",
      "website": "Сайт компании",
      "shareCapital": "Зарегистрированный капитал",
      "shareCapitalCurrencyIsoCode": "Валюта",
      "dateOfIncorporation": "Дата регистрации компании",
      "countryOfIncorporation": "Страна регистрации компании",
      "roleLabel": "Деятельность 1/2",
      "activityId": "Деятельность 2/2",
      "activityRemark": "Описание деятельности",
      "hasBalanceSheetFinancialStatement": "У компании ведется баланс/финансовый отчет?",
      "hasExternalAccounting": "У компании есть внешняя бухгалтерия?",
      "hasPhysicalOffice": "У компании есть физические офисы в {countryName}?",
      "officeCountryIsoCode": "Страна расположения офисов",
      "numberOfEmployees": "Количество сотрудников в офисах",
      "hasEmployeesInPlaceOfIncorporation": "У компании есть сотрудники в {countryName}?",
      "hasDirectorInPlaceOfIncorporation": "У компании есть директор в {countryName}?",
      "holdAnOperatingCompany": "У компании есть действующая операционная компания?",
      "hasReadAndAgreeWithTermsAndConditions": "Я ознакомился(-ась) и принимаю <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/2021_mycim_general-terms-and-conditions-en.pdf\">условия и положения CIM Banque</a>",
      "hasReadAndAgreeWithFeesAndCommissions": "Я ознакомился(-ась) и принимаю условия о <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-company-accounts\">сборах и комиссиях CIM Banque</a>",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Я ознакомился(-ась) и принимаю <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/docs/default-source/pdf/special_risks_security_trading.pdf\">Риски, связанные с торговлей финансовыми инструментами</a>",
      "errors": {
        "addressLine1": "Адрес обязателен",
        "zipCode": "Почтовый индекс обязателен",
        "city": "Город обязателен",
        "residenceCountryIsoCode": "Страна обязательна",
        "shareCapital": "Зарегистрированный капитал обязателен",
        "shareCapitalCurrencyIsoCode": "Валюта обязательна",
        "dateOfIncorporation": "Дата регистрации компании является обязательной и должна быть действительной",
        "pastDateOfIncorporation": "Дата регистрации компании не может быть позже сегодняшнего дня",
        "countryOfIncorporation": "Страна регистрации компании обязательна",
        "officeCountryIsoCode": "Страна расположения офисов обязательна",
        "numberOfEmployees": "Количество сотрудников в офисах обязательна",
        "activityId": "Деятельность обязательна",
        "activityRemark": "Описание деятельности обязательно",
        "hasBalanceSheetFinancialStatement": "Это поле обязательно к заполнению",
        "hasExternalAccounting": "Это поле обязательно к заполнению",
        "hasPhysicalOffice": "Это поле обязательно к заполнению",
        "hasEmployeesInPlaceOfIncorporation": "Это поле обязательно к заполнению",
        "hasDirectorInPlaceOfIncorporation": "Это поле обязательно к заполнению",
        "hasReadAndAgreeWithTermsAndConditions": "Это заявление является обязательным",
        "hasReadAndAgreeWithFeesAndCommissions": "Это заявление является обязательным",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Это заявление является обязательным",
        "holdAnOperatingCompany": "Это поле обязательно к заполнению"
      }
    },
    "companyStructure": {
      "signatory": "Подписант",
      "ubo": "бенефициар",
      "ownershipTotalTitle": "процент владения",
      "ownershipTotalWarning": "процент владения должен быть равен 100%",
      "ownershipTitle": "Собственность",
      "noUBO": "Не добавлен бенефициар",
      "noSignatories": "Подписи не добавлены",
      "addNewEntity": "Добавить бенефициара или подписанта",
      "incompleteRelatedEntites": "По крайней мере, один бенефициар или лицо, подписывающее договор, не заполнено",
      "title": {
        "companyStructure": "Описать структуру компании",
        "relativeEntitySelection": "Люди, участвующие в компании",
        "relativeEntityBeneficialOwnerAdd": "Добавить конечного бенефициарного владельца для {displayName}",
        "relativeEntityBeneficialOwnerEdit": "Редактирование конечного бенефициарного владельца для {displayName}",
        "relativeEntitySignatoryAdd": "Добавить подписанта для {displayName}",
        "relativeEntitySignatoryEdit": "Редактирование подписанта для {displayName}",
        "relativeEntityPowerOfAttorneyAdd": "Добавить подписанта для {displayName}",
        "relativeEntityPowerOfAttorneyEdit": "Редактирование подписанта для {displayName}"
      },
      "deleteModal": {
        "UBOTitle": "Вы уверены, что вы хотите удалить этого бенефициара?",
        "UBOSubtitle": "Вы собираетесь удалить этого бенефициара: {entityName}",
        "signatoryTitle": "Вы уверены, что вы хотите удалить этого подписанта?",
        "signatorySubtitle": "Вы собираетесь удалить этого подписанта: {entityName}"
      }
    },
    "companyRelativeEntitySelection": {
      "addUbo": "Добавить бенефициара",
      "addUboInformation": "Добавить конечного бенефициарного владельца (УБО)",
      "addSignatory": "Добавить подписанта",
      "addSignatoryInformation": "Добавить подписанта (Доверенность)"
    },
    "companyRelativeEntity": {
      "ownership": "Владение",
      "percentageOfOwnership": "Доля владения",
      "personalInformation": "Персональная информация",
      "firstName": "Имя",
      "middleName": "Второе имя",
      "lastName": "Фамилия",
      "nationalityIsoCode": "Гражданство",
      "birthDate": "Дата рождения",
      "cityOfBirth": "Город рождения",
      "countryOfBirthIsoCode": "Страна рождения",
      "contactInformation": "Контактная информация",
      "addressLine1": "Адрес",
      "addressLine2": "Дополнительный адрес",
      "zipCode": "Почтовый индекс",
      "city": "Город",
      "residenceCountryIsoCode": "Страна проживания",
      "mobilePhoneNumber": "Мобильный телефон",
      "email": "Электронная почта обязательна",
      "passportInformation": "Паспортные данные",
      "passportNumber": "Номер паспорта",
      "passportExpirationDate": "Срок действия паспорта",
      "jobInformation": "Информация о работе",
      "role": "Деятельность 1/2",
      "activityId": "Деятельность 2/2",
      "workplaceCountryIsoCode": "Страна расположения рабочего места",
      "isPoliticallyExposed": "Является ли бенефициар политическим деятелем?",
      "isDirector": "Входит ли директор в структуру компании?",
      "taxationInformation": "Информация о налогообложении",
      "taxationCountryIsoCode": "Страна налогообложения",
      "tinNumber": "ИНН",
      "hasTinNumber": "У меня нет номера ИНН",
      "isLinkedToUnitedStates": "Вы имеете отношение к США?",
      "hasUSPassportOrGreenCard": "У вас есть паспорт гражданина США или грин-карта?",
      "hasSpentSubstantialTimeInUS": "Вы когда-нибудь пребывали в США на протяжении более 90 дней?",
      "isUSResidentForAnyOtherReason": "Вы владеете недвижимостью в США?",
      "errors": {
        "firstName": "Имя обязательно",
        "lastName": "Фамилия обязательна",
        "nationalityIsoCode": "Гражданство обязательно",
        "residenceCountryIsoCode": "Страна проживания обязательна",
        "workplaceCountryIsoCode": "Расположение рабочего места обязательно",
        "birthDate": "Дата рождения является обязательной и должна быть действительной",
        "birthDateFuture": "Дата рождения не может быть позже сегодняшнего дня",
        "cityOfBirth": "Город рождения обязателен",
        "countryOfBirthIsoCode": "Страна рождения обязательна",
        "addressLine1": "Адрес обязателен",
        "zipCode": "Почтовый индекс обязателен",
        "city": "Город обязателен",
        "activityId": "Деятельность обязательна",
        "taxationCountryIsoCode": "Страна налогообложения обязательна",
        "isPoliticallyExposed": "Это поле обязательно к заполнению",
        "isDirector": "Это поле обязательно к заполнению",
        "percentageOfOwnership": "Доля владения обязательна",
        "percentageOfOwnershipInteger": "Доля владения должна быть целым числом",
        "percentageOfOwnershipRange": "Доля владения должна находиться в диапазоне от 0 до 100",
        "signature": "Подпись обязательна",
        "passportNumber": "Номер паспорта обязателен",
        "passportExpirationDate": "Срок действия паспорта является обязательным и должен быть действительным",
        "passportExpirationDateOutdated": "Дата должна быть больше, чем сегодняшняя дата",
        "isLinkedToUnitedStates": "Это поле обязательно к заполнению",
        "hasUSPassportOrGreenCard": "Это поле обязательно к заполнению",
        "hasSpentSubstantialTimeInUS": "Это поле обязательно к заполнению",
        "isUSResidentForAnyOtherReason": "Это поле обязательно к заполнению",
        "mobilePhoneNumber": "Номер мобильного телефона обязателен и должен быть действительным (например, +41XXXXXXXXXX)",
        "email": "Электронная почта обязательна",
        "emailValid": "Электронная почта должна быть действительной",
        "tinNumber": "ИНН обязателен"
      }
    },
    "companyTransaction": {
      "title": "Среднее количество трансферов компании в месяц для {displayName}",
      "subtitle": {
        "incomingTransfer": "Входящие трансферы",
        "outgoingTransfer": "Исходящие переводы"
      },
      "averageAmountOfIncomingTransfer": "Объем входящих трансферов",
      "averageAmountOfIncomingTransferCurrencyIsoCode": "Валюта",
      "averageAmountOfOutgoingTransfer": "Объем исходящих переводов",
      "averageAmountOfOutgoingTransferCurrencyIsoCode": "Валюта",
      "numberOfIncomingTransferPerMonth": "Количество переводов / месяц",
      "numberOfOutgoingTransferPerMonth": "Количество переводов / месяц",
      "errors": {
        "averageAmountOfIncomingTransfer": "Объем входящих трансферов является обязательным",
        "averageAmountOfIncomingTransferNumber": "Объем входящих переводов должен быть числом",
        "averageAmountOfIncomingTransferCurrencyIsoCode": "Валюта обязательна",
        "averageAmountOfOutgoingTransfer": "Объем исходящих переводов является обязательным",
        "averageAmountOfOutgoingTransferNumber": "Объем исходящих переводов должен быть числом",
        "averageAmountOfOutgoingTransferCurrencyIsoCode": "Валюта обязательна",
        "numberOfIncomingTransferPerMonth": "Количество переводов является обязательным",
        "numberOfIncomingTransferPerMonthInteger": "Количество переводов должно быть целым числом",
        "numberOfOutgoingTransferPerMonth": "Количество переводов является обязательным",
        "numberOfOutgoingTransferPerMonthInteger": "Количество переводов должно быть целым числом"
      }
    },
    "companyCounterpartyList": {
      "transactions": "Информация о транзакциях",
      "noResults": "Транзакции не добавлены. Пожалуйста, добавьте всех участвующих контрагентов, если это необходимо.",
      "deleteModal": {
        "title": "Вы уверены, что хотите удалить этого контрагента?",
        "subtitle": "Вы собираетесь удалить этого контрагента: {entityName}"
      },
      "listHeaders": {
        "companyName": "Контрагент",
        "nationalityIsoCode": "Гражданство",
        "funds": "Средства",
        "goods": "Товары",
        "from": "От",
        "to": "В",
        "hsCode": "Код ТН ВЭД",
        "operationType": "Тип операции",
        "cashFlowType": "Тип денежного потока",
        "yearlyValuationAmount": "Сумма годового оборота",
        "fundTransferFromCountryIsoCode": "Средства от",
        "fundTransferToCountryIsoCode": "Средства в",
        "commodityFromCountryIsoCode": "Товары от",
        "commodityToCountryIsoCode": "Товары в"
      }
    },
    "companyCounterpartyEdit": {
      "title": "Информация о контрагентах",
      "companyName": "Имя контрагента",
      "nationalityIsoCode": "Гражданство контрагента",
      "fundTransferFromCountry": "Перевод средств из",
      "fundTransferFromSwitzerland": "CIM Banque",
      "fundTransferToCountry": "Перевод средств в",
      "fundTransferToSwitzerland": "CIM Banque",
      "commodityFromCountryIsoCode": "Происхождение товара",
      "commodityToCountryIsoCode": "Назначение товара",
      "productType": "Тип товара",
      "hsCodeChapter": "Код ТН ВЭД Глава",
      "hsCode": "Код ТН ВЭД",
      "operationType": "Тип операции",
      "cashFlowType": "Тип денежного потока",
      "yearlyValuationAmount": "Сумма годового оборота",
      "yearlyValuationCurrencyIsoCode": "Валюта",
      "bankName": "название банка",
      "errors": {
        "companyName": "Имя контрагента является обязательным",
        "nationalityIsoCode": "Гражданство обязательно",
        "fundTransferFromCountryIsoCode": "Обязательным является происхождение средств",
        "fundTransferToCountryIsoCode": "Назначение средств является обязательным",
        "commodityFromCountryIsoCode": "Происхождение товара является обязательным",
        "commodityToCountryIsoCode": "Назначение товара является обязательным",
        "productType": "Тип товара является обязательным",
        "operationType": "Тип операции является обязательным",
        "cashFlowType": "Тип денежного потока является обязательным",
        "yearlyValuationAmount": "Обязательна сумма годового оборота",
        "yearlyValuationAmountNumber": "Годовой оборот должен составлять число",
        "yearlyValuationCurrencyIsoCode": "Обязательно наличие валюты годового оборота",
        "bankName": "Название банка является обязательным"
      }
    },
    "underReview": {
      "title": "Благодарим вас за интерес, проявленный к CIM Banque.",
      "message": "Ваш счет находится в процессе рассмотрения, мы свяжемся с вами, как только процесс будет завершен. Если у Вас возникли вопросы по Вашей заявке, пожалуйста,  <a href='https://www.cimbanque.com/en/the-bank/contact-us/' target='_blank'>обращайтесь к нам</a>."
    },
    "refused": {
      "title": "Благодарим вас за интерес, проявленный к CIM Banque.",
      "message": "Однако с сожалением сообщаем вам, что не можем продолжить рассмотрение вашего запроса на открытие счета."
    },
    "initialDeposit": {
      "title": "Ваш первоначальный взнос",
      "activateAccount": "Чтобы активировать свой счет и получить кредитные карты, пожалуйста, внесите первоначальный депозит (Мин. EUR/CHF/USD 5'000) со <u>своего АКТУАЛЬНОГО ЛИЧНОГО БАНКОВСКОГО счета</u> в течение 15 дней.",
      "activateAccountCorporate": "Чтобы активировать свой счет и получить кредитные карты, пожалуйста, внесите первоначальный депозит (Мин. EUR/CHF/USD 10'000) со <u>своего АКТУАЛЬНОГО БАНКОВСКОГО счета</u> в течение 15 дней.",
      "notice": "Обратите внимание, если вы не пополните свой счет в течение 15 дней, он будет автоматически закрыт."
    },
    "ibanTempo": {
      "name": "Имя",
      "tempIban": "Временный номер IBAN",
      "swift": "Swift (BIC) Code",
      "bankAddress": "Адрес банка",
      "bank": {
        "name": "CIM BANQUE",
        "addressLine1": "RUE MERLE D'AUBIGNE 16",
        "addressLine2": "GENEVA 1211 - Switzerland",
        "swift": "CIMMCHGG"
      }
    }
  }
}
